import { createContext, useContext } from "react";
import { PendingLicencePurchase } from "../../types/PendingLicencePurchase/PendingLicencePurchase";

export interface PurchaseLicenceContextType {
  loading: boolean;
  onPurchaseLicence: (
    licenceId: string,
    licenceType?: string,
    numberOfUsers?: number
  ) => void;
}
const PurchaseLicenceContext = createContext<
  PurchaseLicenceContextType | undefined
>(undefined);

const usePurchaseLicenceContext = () => {
  const context = useContext(PurchaseLicenceContext);

  if (context === undefined) {
    throw new Error(
      "usePurchaseLicenceContext was used outside of its Provider"
    );
  }

  return context;
};

export { PurchaseLicenceContext, usePurchaseLicenceContext };
